var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7196 3.21969C16.0124 2.92677 16.4873 2.92677 16.7801 3.21969C17.073 3.51261 17.073 3.98752 16.7801 4.28044L11.0615 10.0001L16.7821 15.7217C17.075 16.0146 17.075 16.4895 16.7821 16.7824C16.4893 17.0753 16.0144 17.0753 15.7216 16.7824L10.0009 11.0608L4.28022 16.7824C3.98736 17.0753 3.51252 17.0753 3.21965 16.7824C2.92678 16.4895 2.92678 16.0146 3.21965 15.7217L8.94032 10.0001L3.22164 4.28044C2.92877 3.98752 2.92877 3.51261 3.22164 3.21969C3.51451 2.92677 3.98934 2.92677 4.28221 3.21969L10.0009 8.93932L15.7196 3.21969Z",
    fill: "currentColor"
  })));
};
export default SvgClose;